<template>
  <div>
    <v-title>Recurring Charge Details</v-title>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <v-card>
        <v-card-text>
          <v-container pa-0 fluid grid-list-md>
            <v-layout row wrap>
              <v-flex pb-2 xs12 md6>
                <vonex-text
                  v-model="chargeDetails.customerNo"
                  label="Customer No"
                  name="CustomerNo"
                  class="text-right"
                  hide-details
                  :rule="`required`"
                  :options="fieldConditions"
                ></vonex-text>
              </v-flex>
              <v-flex xs12 md6>
                <vonex-text
                  v-model="chargeDetails.serviceNo"
                  label="Service No"
                  name="ServiceNo"
                  class="text-right"
                  hide-details
                  :rule="`required`"
                  :options="fieldConditions"
                ></vonex-text>
              </v-flex>
              <v-flex xs12 md6>
                <vonex-autocomplete
                  v-model="extension.ratePlanID"
                  hide-details
                  class="form-control custom-td"
                  :name="'ratePlanID' + index"
                  :rule="'planId'"
                  :items="
                    validRatePlans(
                      extension.contractLengthMonths,
                      index,
                      extension.softPhone
                    )
                  "
                  dense
                  flat
                  item-value="ratePlanID"
                  item-text="ratePlanDescription"
                  :options="fieldConditions"
                  :disabled="index > 0 && planGroup == 'lineshare'"
                  @change="updateRowPlans(index)"
                >
                  <template slot="selection" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                  <template slot="no-data">Choose contract length</template>
                  <template slot="item" slot-scope="data">
                    <span class="ellipsis">
                      {{ data.item.ratePlanDescription }}
                    </span>
                  </template>
                </vonex-autocomplete>
                <vonex-text
                  v-model="chargeDetails.code"
                  label="Tariff Code"
                  name="TariffCode"
                  class="text-right"
                  hide-details
                  :rule="`required`"
                  :options="fieldConditions"
                ></vonex-text>
              </v-flex>
              <v-flex xs12 md6>
                <vonex-date
                  ref="startDate"
                  v-model="chargeDetails.startDate"
                  class="form-group"
                  name="startDate"
                  label="Start Date"
                  :rule="`required`"
                  :options="fieldConditions"
                ></vonex-date>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" :disabled="invalid" text @click="save">Save</v-btn>
          <v-btn class="light" text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapInstallationChargesActions,
} = createNamespacedHelpers(`orders/installationCharges`);
export default {
  name: 'RecurringChargeDetails',
  props: {
    charge: { type: Object, required: true },
    recurringChargeDetails: { type: Object, required: true },
    isViewing: { type: Boolean, required: true },
  },
  data() {
    return {
      chargeDetails: {},
      menu: false,
    };
  },
  computed: {
    ...mapOrderState(['rows']),
  },
  methods: {
    ...mapInstallationChargesActions(['addRecurringChargeDetails']),
    save() {
      let vm = this;
      vm.$refs.observer.validate().then(async (result) => {
        if (result) {
          vm.chargeDetails.orderID = vm.rows[0].orderID;
          vm.addRecurringChargeDetails(vm.chargeDetails).then((data) => {
            if (data.status == 200)
              vm.$emit('recurringChargeDetails', data.data);
          });
        }
      });
    },
  },
  mounted() {
    let vm = this;
    vm.chargeDetails = vm.recurringChargeDetails;
    vm.chargeDetails.amountRecurring = vm.charge.totalCost;

    console.log(vm.chargeDetails)
  },
};
</script>
